/*
 * Copyright (c) 2026. Tooling Team
 */

import { EditableTableCell } from "@uhg-abyss/web/ui/DataTable";
import { MAPPING_STATUS_OPTIONS } from "../../utils/constants";

const MappingStatusCell = (cell) => (
  <EditableTableCell
    {...cell}
    inputType="select"
    options={MAPPING_STATUS_OPTIONS}
  />
);

export default MappingStatusCell;
